import type { ModuleMetric } from '@/components/admin/ModuleLayout';
import { CalenderIcon, CheckCircleIcon, GroupIcon, TimeIcon } from '@/icons';

// Forma común a AdminEvent y AdminRegionalEvent/AdminRegionalEventDetail — la
// API ya nombra estos campos igual para ambos tipos, así que el shell de
// stats puede ser una sola función en vez de duplicarse por tipo de evento.
export interface EventLikeStats {
  eventStartDate: string;
  eventEndDate: string;
  registrationStartDate: string;
  registrationDeadline: string;
  isActive: boolean;
  _count: { teams: number };
}

function formatShortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('es-CO');
}

// Nacional y regional deben verse 100% iguales — un solo builder de métricas
// para EventDetailPage y RegionalDetailPage (ver cccd-ux-redesign).
export function buildEventStatMetrics(entity: EventLikeStats, teamsHint: string): ModuleMetric[] {
  const deadlinePassed = new Date(entity.registrationDeadline) < new Date();
  const deadlineNeedsAction = deadlinePassed && entity.isActive;

  return [
    { label: 'Total equipos', value: String(entity._count.teams), hint: teamsHint, icon: <GroupIcon className="size-4" /> },
    { label: 'Inicio del concurso', value: formatShortDate(entity.eventStartDate), icon: <CalenderIcon className="size-4" /> },
    { label: 'Fin del concurso', value: formatShortDate(entity.eventEndDate), icon: <CheckCircleIcon className="size-4" /> },
    {
      label: 'Cierre inscripciones',
      value: formatShortDate(entity.registrationDeadline),
      tone: deadlineNeedsAction ? 'warning' : 'neutral',
      hint: deadlineNeedsAction ? 'Ya venció y las inscripciones siguen abiertas' : undefined,
      icon: <TimeIcon className="size-4" />,
    },
  ];
}
